const CloseIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    className='w-6 h-6 mr-1'
    viewBox='0 0 20 20'
    fill='#808080'
  >
    <path
      fillRule='#808080'
      d='M13.414 10l4.293-4.293a1 1 0 00-1.414-1.414L12 8.586 7.707 4.293a1 1 0 10-1.414 1.414L10.586 10l-4.293 4.293a1 1 0 101.414 1.414L12 11.414l4.293 4.293a1 1 0 001.414-1.414L13.414 10z'
      clipRule='#808080'
    />
  </svg>
)

export default CloseIcon
